import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import NewsletterForm from '@/components/base/NewsletterForm';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import AboutPreview from './components/AboutPreview';
import FAQSection from '@/components/base/FAQSection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '亚洲人成长之路 - 全方位发展指南',
          description: '探索亚洲人成长的核心议题，涵盖职业发展规划、个人成长方法论、文化认同与自我提升。',
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedArticles />
          <AboutPreview />
          <FAQSection />
          <NewsletterForm />
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}